import React from 'react';
import Icon from '../../../components/AppIcon';

const RANK_COLORS = [
  { bg: 'bg-amber-500', text: 'text-amber-500', glow: 'shadow-amber-500/30' },
  { bg: 'bg-slate-400', text: 'text-slate-400', glow: 'shadow-slate-400/30' },
  { bg: 'bg-orange-600', text: 'text-orange-600', glow: 'shadow-orange-600/30' },
];

const CampaignRow = ({ campaign, rank, maxEarned }) => {
  const rankStyle = RANK_COLORS?.[rank - 1] || { bg: 'bg-muted', text: 'text-muted-foreground', glow: '' };
  const progressPct = maxEarned > 0 ? Math.min((campaign?.earned / maxEarned) * 100, 100) : 0;

  return (
    <div className="flex items-center gap-3 py-3 border-b border-border/50 last:border-0">
      {/* Rank */}
      <div className={`w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold text-white ${rankStyle?.bg} shadow-md ${rankStyle?.glow} flex-shrink-0`}>
        {rank}
      </div>

      {/* Campaign Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1.5">
          <p className="text-sm font-medium text-foreground truncate pr-2">{campaign?.title || 'Campaign'}</p>
          <span className="text-sm font-bold text-primary data-text flex-shrink-0">${parseFloat(campaign?.earned || 0)?.toFixed(2)}</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-700"
              style={{
                width: `${progressPct}%`,
                background: rank === 1
                  ? 'linear-gradient(90deg, #14B8A6, #F59E0B)'
                  : rank === 2
                  ? 'linear-gradient(90deg, #14B8A6, #3B82F6)'
                  : 'linear-gradient(90deg, #3B82F6, #8B5CF6)',
              }}
            />
          </div>
          <span className="text-xs text-muted-foreground flex-shrink-0">{campaign?.participations || 0} submissions</span>
        </div>
      </div>
    </div>
  );
};

const TopCampaignsRanking = ({ campaigns, loading }) => {
  const maxEarned = campaigns?.length ? Math.max(...campaigns?.map(c => c?.earned || 0)) : 0;
  const totalEarned = campaigns?.reduce((s, c) => s + (c?.earned || 0), 0);

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <div className="px-5 py-4 border-b border-border flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-amber-500/15 flex items-center justify-center">
            <Icon name="Trophy" size={18} className="text-amber-500" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground font-heading">Top Campaigns</h3>
            <p className="text-xs text-muted-foreground">Ranked by cashback earned</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm font-bold text-foreground data-text">${totalEarned?.toFixed(2)}</p>
          <p className="text-xs text-muted-foreground">total earned</p>
        </div>
      </div>

      <div className="px-5 py-2">
        {loading ? (
          <div className="py-8 flex items-center justify-center">
            <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          </div>
        ) : campaigns?.length === 0 ? (
          <div className="py-8 text-center">
            <Icon name="Trophy" size={28} className="text-muted-foreground mx-auto mb-2" />
            <p className="text-sm text-muted-foreground">No campaign data yet</p>
          </div>
        ) : (
          campaigns?.slice(0, 5)?.map((campaign, idx) => (
            <CampaignRow
              key={campaign?.id || idx}
              campaign={campaign}
              rank={idx + 1}
              maxEarned={maxEarned}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default TopCampaignsRanking;
